import React from 'react'
import { WhatWeDo } from "../components/WhatWeDo"
import TestimonialsSlider from '../components/TestimonialsSlider'
import '../css/about.css'

export const About = () => {
  return (

<>
    <div className="page_content_wrap pt-0 pb-0">
      <div className=" bgcolor_servicetop ">
        <div className="bg-background min-h-screen py-5 py-sm-about-0">
          <section className="container mx-auto px-4 py-16 md:py-24 lg:py-32">
            <div className="flex flex-col items-center justify-center text-center">
              <h1 className="text-center text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground mb-6 md:mb-8">
                About
              </h1>
              <i className="fa-solid fa-chevron-down text-2xl text-foreground mt-2"></i>
            </div>
          </section>
        </div>
      </div>
      <div className="content_wrap">

        <div className="content">
          <span
            id="content_skip_link_anchor"
            className="agricola_skip_link_anchor"
          />
          <article
            id="post-17668"
            className="post_item_single post_type_page post-17668 page type-page status-publish hentry"
          >
            <div className="post_content entry-content">
              <div
                data-elementor-type="wp-page"
                data-elementor-id={17668}
                className="elementor elementor-17668"
              >
                {/* <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-4176eed elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="4176eed"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-960e8f6 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="960e8f6"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-26b3f75 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="26b3f75"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section> */}
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-56b2aa4 elementor-section-stretched scheme_light elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="56b2aa4"
                  data-element_type="section"
                  data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                  style={{ width: 375, left: "-10px" }}
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-276299f sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="276299f"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-eefb02d sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="eefb02d"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-686d20d elementor-section-content-middle elementor-section-stretched scheme_light elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="686d20d"
                  data-element_type="section"
                  data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                  style={{ width: 375, left: "-10px" }}
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7aaddb2 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="7aaddb2"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <section
                          className="elementor-section elementor-inner-section elementor-element elementor-element-af0b09c elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="af0b09c"
                          data-element_type="section"
                        >
                          <div className="elementor-container elementor-column-gap-no">
                            <div
                              className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-c29f502 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="c29f502"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-2fb9a90 no-title sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="2fb9a90"
                                  data-element_type="widget"
                                  data-widget_type="image.default"
                                >
                                  <div className="elementor-widget-container">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={660}
                                      height={879}
                                      src="https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-9-copyright.jpg"
                                      className="attachment-full size-full wp-image-19219"
                                      alt=""
                                      srcSet="https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-9-copyright.jpg 660w, https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-9-copyright-600x799.jpg 600w, https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-9-copyright-225x300.jpg 225w, https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-9-copyright-370x493.jpg 370w, https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-9-copyright-410x546.jpg 410w"
                                      sizes="(max-width: 660px) 100vw, 660px"
                                    />{" "}
                                  </div>
                                </div>
                                <div
                                  className="elementor-element elementor-element-f6a38ba sc_height_large sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="f6a38ba"
                                  data-element_type="widget"
                                  data-widget_type="spacer.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="elementor-spacer">
                                      <div className="elementor-spacer-inner" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-5167102 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id={5167102}
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-a33e316 no-title sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="a33e316"
                                  data-element_type="widget"
                                  data-widget_type="image.default"
                                >
                                  <div className="elementor-widget-container">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={615}
                                      height={675}
                                      src="https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-10-copyright.jpg"
                                      className="attachment-full size-full wp-image-19220"
                                      alt=""
                                      srcSet="https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-10-copyright.jpg 615w, https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-10-copyright-600x659.jpg 600w, https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-10-copyright-273x300.jpg 273w, https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-10-copyright-370x406.jpg 370w, https://agricola.axiomthemes.com/wp-content/uploads/2022/07/custom-img-10-copyright-410x450.jpg 410w"
                                      sizes="(max-width: 615px) 100vw, 615px"
                                    />{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3ae80f5 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="3ae80f5"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-f15afdd sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="f15afdd"
                          data-element_type="widget"
                          data-widget_type="trx_sc_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_title color_style_dark sc_title_default">
                              {/* <span className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default">
                                our process
                              </span> */}
                              <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                                <span className="sc_item_title_text">
                                  Who We Are
                                </span>
                              </h1>
                            </div>{" "}
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-284c79c sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="284c79c"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-ff37402 sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="ff37402"
                          data-element_type="widget"
                          data-widget_type="text-editor.default"
                        >
                          <div className="elementor-widget-container">
                            <p>
                              Golden Agriculture is a trusted name in agri-commodity trading, established in Oman to serve the growing demand for structured, compliant, and regionally integrated sourcing solutions. We serve as a key link between large-scale producers and institutional buyers, offering supply chain reliability backed by rigorous quality standards.
                            </p>{" "}
                          </div>
                        </div>

                        <div
                          className="elementor-element elementor-element-f642746 sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="f642746"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-ff37402 sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="ff37402"
                          data-element_type="widget"
                          data-widget_type="text-editor.default"
                        >
                          <div className="elementor-widget-container">
                            <p>
                              As a company built by industry veterans, we focus not only on moving goods but also on delivering assurance, with every contract, inspection, and delivery. Our goal is to simplify and professionalize agricultural trade from Oman to markets across the GCC and Asia.

                            </p>{" "}
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-9f1682d sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="9f1682d"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-4ceda38 sc_fly_static elementor-widget elementor-widget-trx_sc_button trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="4ceda38"
                          data-element_type="widget"
                          data-widget_type="trx_sc_button.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_item_button sc_button_wrap">
                              <a
                                href="/services"
                                className="sc_button sc_button_default sc_button_size_normal sc_button_icon_left"
                              >
                                <span className="sc_button_text">
                                  <span className="sc_button_title">
                                    Our Services
                                  </span>
                                </span>
                              </a>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-c961602 elementor-section-stretched scheme_light elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="c961602"
                  data-element_type="section"
                  data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                  style={{ width: 375, left: "-10px" }}
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7436da5 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="7436da5"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-8ce6353 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="8ce6353"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
         </div>
            </div>
            
          </article>
        </div>
      </div>
    </div>
       
         <section
                  className="elementor-section elementor-top-section mobile-top-section  elementor-element elementor-element-28bc2dd scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited py-5"
                  data-id="28bc2dd"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                 style={{background:"#FAF7F0"}}
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-922bf7a sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="922bf7a"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        {/* <div
                            className="elementor-element elementor-element-834239e sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                            data-id="834239e"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}
                        <section
                          className="elementor-section elementor-inner-section elementor-element elementor-element-1829b4c elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="1829b4c"
                          data-element_type="section"
                        >
                          <div className="elementor-container elementor-column-gap-extended">
                            <div
                              className="elementor-column elementor-col-16 elementor-inner-column elementor-element elementor-element-af70ce8 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="af70ce8"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap"></div>
                            </div>
                            <div
                              className="elementor-column elementor-col-66 elementor-inner-column elementor-element elementor-element-f46bc00 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="f46bc00"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-fa970e5 elementor-view-default sc_fly_static elementor-widget elementor-widget-icon trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="fa970e5"
                                  data-element_type="widget"
                                  data-widget_type="icon.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="elementor-icon-wrapper">
                                      <div className="elementor-icon"></div>
                                    </div>
                                  </div>
                                </div>
                                {/* <div
                              className="elementor-element elementor-element-102c71a sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="102c71a"
                              data-element_type="widget"
                              data-widget_type="spacer.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-spacer">
                                  <div className="elementor-spacer-inner" />
                                </div>
                              </div>
                            </div> */}
                                <div
                                  className="elementor-element elementor-element-b04d221 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="b04d221"
                                  data-element_type="widget"
                                  data-widget_type="trx_sc_title.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="sc_title color_style_dark sc_title_default">
                                      <span className="sc_item_subtitle sc_title_subtitle sc_align_center sc_item_subtitle_above sc_item_title_style_default">
                                        Our Agricultural Company
                                      </span>
                                      <h1 className="sc_item_title sc_title_title sc_align_center sc_item_title_style_default sc_item_title_tag pb-xxl-5">
                                        <span className="sc_item_title_text">
                                          We’re a World-Leading Provider of
                                          Organic Products
                                        </span>
                                      </h1>
                                    </div>{" "}
                                  </div>
                                </div>
                                <div
                                  className="elementor-element elementor-element-a76e895 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="a76e895"
                                  data-element_type="widget"
                                  data-widget_type="spacer.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="elementor-spacer">
                                      <div className="elementor-spacer-inner" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-16 elementor-inner-column elementor-element elementor-element-4531850 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id={4531850}
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap"></div>
                            </div>
                          </div>
                        </section>
                        <section
                          className="elementor-section elementor-inner-section elementor-element elementor-element-44e6485 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="44e6485"
                          data-element_type="section"
                        >
                          <div className="elementor-container elementor-column-gap-extended">
                            <div
                              className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-89d2c79 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="89d2c79"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-f487705 sc_fly_static elementor-widget elementor-widget-trx_sc_icons trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="f487705"
                                  data-element_type="widget"
                                  data-widget_type="trx_sc_icons.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="sc_icons sc_icons_common sc_icons_size_medium sc_align_none">
                                      <div className="sc_icons_item">
                                        <div className="sc_icons_image">
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            src="/img/company/61060.jpg"
                                            alt="Icon"
                                            width={600}
                                            // height={900}
                                            style={{ height: "260px" }}
                                          />
                                        </div>
                                        <div className="sc_icons_item_details">
                                          <h4 className="sc_icons_item_title">
                                            <span>Mission</span>
                                          </h4>
                                          <div className="sc_icons_item_description">
                                            <span>
                                              <p>To reliably link agricultural producers with buyers in regional and global markets, while upholding quality, ethics, and long-term food security. We aim to be more than traders, we aim to be problem-solvers for our clients. </p>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* /.sc_icons */}{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-a3455ae sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="a3455ae"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-bd179a6 sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="bd179a6"
                                  data-element_type="widget"
                                  data-widget_type="spacer.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="elementor-spacer">
                                      <div className="elementor-spacer-inner" />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-element elementor-element-a6d3173 sc_fly_static elementor-widget elementor-widget-trx_sc_icons trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="a6d3173"
                                  data-element_type="widget"
                                  data-widget_type="trx_sc_icons.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="sc_icons sc_icons_common sc_icons_size_medium sc_align_none">
                                      <div className="sc_icons_item">
                                        <div className="sc_icons_image">
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            src="/img/company/farmer-standing-rice-field-with-tablet.jpg"
                                            alt="Icon"
                                            width={600}
                                            // height={674}
                                            style={{ height: "260px" }}
                                          />
                                        </div>
                                        <div className="sc_icons_item_details">
                                          <h4 className="sc_icons_item_title">
                                            <span>Vision</span>
                                          </h4>
                                          <div className="sc_icons_item_description">
                                            <span>
                                              <p>
                                                To become the leading Omani exporter and regional partner of choice in agri-commodities by combining scale, specialization, and service excellence. We envision a trading network where quality and trust define every transaction.
                                              </p>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* /.sc_icons */}{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b97ac8d sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="b97ac8d"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-a3f81a7 sc_fly_static elementor-widget elementor-widget-trx_sc_icons trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="a3f81a7"
                                  data-element_type="widget"
                                  data-widget_type="trx_sc_icons.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="sc_icons sc_icons_common sc_icons_size_medium sc_align_none">
                                      <div className="sc_icons_item">
                                        <div className="sc_icons_image">
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            src="/img/company/879.jpg"
                                            alt="Icon"
                                            width={600}
                                            // height={674}
                                            style={{ height: "260px" }}
                                          />
                                        </div>
                                        <div className="sc_icons_item_details">
                                          <h4 className="sc_icons_item_title pb-2">
                                            <span>Our Core Values</span>
                                          </h4>
                                          <div className="sc_icons_item_description">
                                            <span>
                                              <p>
                                                At Golden Agriculture, our values shape every relationship and decision we make. We operate with integrity in all transactions, maintaining the highest standards of quality and reliability across our supply chain.
                                              </p>
                                            </span>
                                          </div>
                                          {/* <div className="">
                                        <span>
                                          <ul>
                                            <li>Integrity</li>
                                            <li>Quality</li>
                                            <li>Reliability</li>
                                            <li>Traceability</li>
                                            <li>Partnership Focus</li>
                                            <li>Sustainability</li>




                                          </ul>
                                        </span>
                                      </div> */}
                                        </div>
                                      </div>
                                    </div>
                                    {/* /.sc_icons */}{" "}
                                  </div>
                                </div>
                              </div>
                            </div>





                          </div>
                        </section>

                      </div>
                    </div>
                  </div>
                </section>

             <div className="content_wrap">

        <div className="content">
          <span
            id="content_skip_link_anchor"
            className="agricola_skip_link_anchor"
          />
          <article
            id="post-17668"
            className="post_item_single post_type_page post-17668 page type-page status-publish hentry"
          >
            <div className="post_content entry-content">
              <div
                data-elementor-type="wp-page"
                data-elementor-id={17668}
                className="elementor elementor-17668"
              >
                <section
                  className=""
                  data-id="686d20d"
                  data-element_type="section"
                  data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                >
                  <div className="">


                    <div className="elementor-widget-wrap elementor-element-populated container">

                      {/* <div
                            className="elementor-element elementor-element-834239e sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                            data-id="834239e"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-spacer">
                                <div className="elementor-spacer-inner" />
                              </div>
                            </div>
                          </div> */}



                      <div className="">
                        <div className="row align-items-center">

                          <div className="col-12 col-md-6 p-0">
                            <img src="/video/our_history.png" alt="About Us" className="img-fluid w-100" />
                          </div>


                          <div className="col-12 col-md-6 p-0">
                            <h3 className="fw-bold mb-3">Our History</h3>
                            <p>
                              While Golden Agriculture was formally established in the 2020s, our leadership team brings over
                              40 years of experience in agricultural trade, logistics, and commodity markets. The idea for Golden
                              Agriculture was born out of Oman’s growing importance as a regional logistics and trade hub. Leveraging
                              long-standing networks across the GCC, Indian subcontinent, and Asia, we created a company designed to meet today’s
                              high standards in agri-trade, particularly for traceability, sustainability, and timely delivery
                            </p>

                          </div>
                        </div>
                      </div>


                    </div>

                  </div>
                </section>


  


                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-35ec590 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static"
                  data-id="35ec590"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1119ddc sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                      data-id="1119ddc"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-4e0ed3e sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer"
                          data-id="4e0ed3e"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <TestimonialsSlider />

         </div>
            </div>
            
          </article>
        </div>
      </div>
     
</>

  )
}
